const routes = {
  root: "/",
  newBooks: "/new_books",
  suggestedBooks: "/suggested_books",
  similarBooks: "/similar_books",
  startedBooks: "/started_books",
  notStartedBooks: "/not_started_books",
  finishedBooks: "/finished_books",
  authorBooks: "/author_books",
  book: "/book",
  search: "/search",
  searchBooks: "/search_genre_books",
  booksShelf: "/books_shelf",
  searchTopBooks: "/search_top_books",
  searchNewBooks: "/search_new_books",
  reading: "/reading",
  askQuestion: "/ask_question",
  chooseAvatar: "/choose_avatar",
  audioBook: "/audio_book",
  error404: `/404`,
};
export default routes;
